import { TeacherDashboardData } from "../types/teacherDashboard";
import axiosInstance from "../api/apiInterceptor";
import { AxiosResponse } from "axios";
import { REPORT_API_ENDPOINT } from "../../../constants/constants";

export interface TeacherDashboardParams {
	startDate: string;
	endDate: string;
	schoolIds: string; // or string if API accepts comma-separated
	isCumulative: boolean;
} 
// const REPORT_API_ENDPOINT = "/reports";

export const fetchTeacherDashboardApi = async (
	params: TeacherDashboardParams
): Promise<TeacherDashboardData> => {
	try {
		const response: AxiosResponse<any> = await axiosInstance.get(
			REPORT_API_ENDPOINT,
			{ params }
		);

		// Optional: check for success status code
		if (response.status === 200 && response.data?.data) {
			return response.data.data;
		} else {
			throw new Error(
				response.data?.message || "Unexpected response from server"
			);
		}
	} catch (error: any) {
		// Optional: log to service like Sentry
		console.error("Failed to fetch report:", error);

		// Re-throw a clean error for the caller (component or redux)
		throw new Error(
			error?.response?.data?.message ||
			error.message ||
			"Failed to fetch report data"
		);
	}
};
